import { Component, OnInit } from '@angular/core';
import { ContentfulService } from '../../core/contentful.service';
import { Entry } from 'contentful';
import { SeoService } from '../../core/seo.service';

@Component({
  selector: 'app-daily',
  templateUrl: './daily.component.html',
  styleUrls: ['./daily.component.css']
})
export class DailyComponent implements OnInit {
  public blmDaily: Entry<any>[] = [];
  constructor(
    private contentfulService: ContentfulService,
    private seo: SeoService
  ) { }

  ngOnInit() {
    this.seo.updateTags({
      title: 'Museum Stories & Journal',
      description: 'Read the latest stories, artifact spotlights, and cultural reflections from Bayou Lacombe Museum in St. Tammany Parish, Louisiana.',
      url: '/daily'
    });
    this.contentfulService.getDaily()
    .then(blmDaily => this.blmDaily = blmDaily);
  }

}
